'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$proto$StoreTwoFactorAuthRequestPayload$$anon$174() {
  this.cfd = null;
  this.cfb = null;
  this.cfc = false;
  this.cf9 = null;
  this.cfa = false;
  this.cfe = false;
  this.cff = false;
  this.cfd = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_types$proto$StoreTwoFactorAuthRequestPayload$$anon$174 as $c_Lpresto_types$proto$StoreTwoFactorAuthRequestPayload$$anon$174 };
$p = $c_Lpresto_types$proto$StoreTwoFactorAuthRequestPayload$$anon$174.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$proto$StoreTwoFactorAuthRequestPayload$$anon$174;
/** @constructor */
function $h_Lpresto_types$proto$StoreTwoFactorAuthRequestPayload$$anon$174() {
}
export { $h_Lpresto_types$proto$StoreTwoFactorAuthRequestPayload$$anon$174 as $h_Lpresto_types$proto$StoreTwoFactorAuthRequestPayload$$anon$174 };
$h_Lpresto_types$proto$StoreTwoFactorAuthRequestPayload$$anon$174.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.cfd;
});
$p.t = (function() {
  if ((!this.cfc)) {
    this.cfb = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("email", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.cfc = true;
  }
  return this.cfb;
});
$p.ae = (function() {
  if ((!this.cfa)) {
    this.cf9 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.cfa = true;
  }
  return this.cf9;
});
$p.w = (function() {
  if ((!this.cff)) {
    this.cfe = false;
    this.cff = true;
  }
  return this.cfe;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_types$proto$StoreTwoFactorAuthRequestPayload$$anon$174 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$proto$StoreTwoFactorAuthRequestPayload$$anon$174, "presto.types$proto$StoreTwoFactorAuthRequestPayload$$anon$174", ({
  a3B: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_types$proto$StoreTwoFactorAuthRequestPayload$$anon$174 as $d_Lpresto_types$proto$StoreTwoFactorAuthRequestPayload$$anon$174 };
//# sourceMappingURL=presto.types$proto$-Store-Two-Factor-Auth-Request-Payload$$anon$174.js.map
